import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useSelector } from 'react-redux';

const Section3 = () => {
  const eventData = useSelector((state) => state.event.eventData);
  const people = eventData.subpeople.communitydata  || [];
  console.log("people", people);

  return (
    <section
      className="team-area3 position-relative bg-top-center space"
    >
      <div className="container z-index-common">
        <div className="title-area text-center">
          <span className="sub-title">{eventData.subpeople.Heading}</span>
          <h2 className="sec-title">{eventData.subpeople.Subheading}</h2>
        </div>
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000 }}
          loop
          breakpoints={{
            0: { slidesPerView: 1 },
            576: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
            1200: { slidesPerView: 3 },
          }}
          className="teamSlider3 has-shadow"
        >
          {people.map((person, idx) => (
            <SwiperSlide key={idx}>
              <div className="th-team team-grid"  style={{border:"1px solid gray"}}>
                <div className="team-img">
                  <img src={person.imageKey1 || 'assets/img/default.jpg'} alt="Team" />
                </div>
                <div className="team-img2">
                  <img src={person.imageKey2 || 'assets/img/default2.jpg'} alt="Team" />
                </div>
                <div className="team-content">
                  <div className="media-body">
                    <h3 className="box-title">
                      <a href="#!">{person.name}</a>
                    </h3>
                    <span className="team-desig">{person.date}</span>
                    <div className="th-social">
                      {['facebook', 'twitter', 'linkedin', 'instagram'].map((platform, i) => (
                        <a
                          key={i}
                          href={person.peopleData?.peopleData?.[platform] || `https://${platform}.com`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className={`fab fa-${platform}${platform === 'facebook' ? '-f' : ''}`}></i>
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Section3;
